import {CSSObject, forBrands, styled, Theme} from "@core-ui/react-stitch";
import {SubheadingThemedProps} from "../types";

const gapGapfsCustomTextStyles = (theme: Theme) =>
  ({
    padding: "0 0.5rem",
    "&::before, &::after": {
      borderTop: `2px solid ${theme.color.g2}`,
      display: "block",
      position: "absolute",
      width: "100em",
      top: "50%",
      content: "''",
    },

    "&::before": {
      right: "100%",
    },
    "&::after": {
      left: "100%",
    },
  } as CSSObject);

const brCustomTextStyles = (
  theme: Theme,
  brTertiaryFontsEnabled: boolean,
  isMobile: boolean
) => {
  let textStyle = {};

  textStyle = {
    color: theme.color.inverse.b1,
    fontWeight: "400",
    lineHeight: "1.8rem",
    letterSpacing: "0.033rem",
    fontSize: isMobile ? "1rem" : "1.5rem",
  };

  if (brTertiaryFontsEnabled) {
    textStyle = {
      ...theme.font.tertiary,
      fontWeight: "400",
      letterSpacing: "-0.02em",
    };
  }

  return {
    display: "block",
    textAlign: "center",
    fontWeight: "300",
    ...theme.brandFontAlt,
    ...textStyle,
  };
};

const oldNavyCustomTextStyles = () => ({
  letterSpacing: "0.1em",
});

const customTextStyles = (
  theme: Theme,
  brTertiaryFontsEnabled = false,
  isMobile = false
) =>
  forBrands(theme, {
    gap: () => gapGapfsCustomTextStyles(theme) as CSSObject,
    gapfs: () => gapGapfsCustomTextStyles(theme) as CSSObject,
    on: () => oldNavyCustomTextStyles() as CSSObject,
    br: () =>
      brCustomTextStyles(theme, brTertiaryFontsEnabled, isMobile) as CSSObject,
    brfs: () =>
      brCustomTextStyles(theme, brTertiaryFontsEnabled, isMobile) as CSSObject,
    default: () => ({}),
  }) as CSSObject;

export const Subheading = styled.h2(
  ({theme, brTertiaryFontsEnabled, isMobile}: SubheadingThemedProps) => ({
    textTransform: "uppercase",
    letterSpacing: "0.15em",
    display: "inline-block",
    position: "relative",
    ...customTextStyles(theme, brTertiaryFontsEnabled, isMobile),
  })
);
